let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("58BdM")).then(() => parcelRequire('9tnlT'));